import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBolt,
  faFileContract,
  faSuitcaseRolling,
  faPlaneDeparture,
  faHeadset,
  faLanguage,
} from '@fortawesome/free-solid-svg-icons';

import { aiProjects } from '../../data';
import useInView from '../../hooks/useInView';
import SectionHeading from '../ui/SectionHeading';
import SpotlightCard from '../ui/SpotlightCard';

import '../../styles/AiLab/AiLab.scss';

const ICONS = {
  procurement: faFileContract,
  'ops-copilot': faPlaneDeparture,
  baggage: faSuitcaseRolling,
  'support-rag': faHeadset,
  'kiosk-assistant': faLanguage,
};

const STATUS_CLASS = { Built: 'built', 'In production': 'live' };

export default function AiLab() {
  const [gridRef, inView] = useInView({ threshold: 0.05 });

  return (
    <section className="section ai-lab" id="ai" aria-labelledby="ai-title">
      <div className="container">
        <SectionHeading
          index="03"
          eyebrow="AI & LLM engineering"
          id="ai-title"
          title="Putting LLMs"
          accent="to real work."
          description="OpenAI, LangChain and LangGraph features, often shipped as a Forward Deployed Engineer."
        />

        <ul ref={gridRef} className={`ai-lab__grid${inView ? ' is-in' : ''}`}>
          {aiProjects.map((p, i) => (
            <li key={p.id} className={`ai-card ai-card--${p.id}`} style={{ '--order': i }}>
              <SpotlightCard as="article" tilt className="ai-card__inner" aria-labelledby={`ai-${p.id}`}>
                <div className="ai-card__head">
                  <span className="ai-card__icon" aria-hidden="true">
                    <FontAwesomeIcon icon={ICONS[p.id] || faBolt} />
                  </span>
                  <span className={`ai-card__status ai-card__status--${STATUS_CLASS[p.status] || 'case'}`}>
                    {p.status}
                  </span>
                </div>
                <p className="ai-card__kind">{p.kind}</p>
                <h3 id={`ai-${p.id}`} className="ai-card__title">
                  {p.title}
                </h3>
                <p className="ai-card__summary">{p.summary}</p>
                <ul className="ai-card__tags" aria-label="Technologies">
                  {p.tags.map((t) => (
                    <li key={t} className="chip">
                      {t}
                    </li>
                  ))}
                </ul>
              </SpotlightCard>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
